import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, HostBinding } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseComponent, Shell, SiteWideAlert } from '@tytapp/common';

import { AppConfig } from '../../common/app-config';
import { UserService } from '../../user';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiUser } from '@tytapp/api';
import { environment } from 'environments/environment';

@Component({
  selector: 'tyt-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent extends BaseComponent {

  constructor(
    private router : Router,
    private appConfig : AppConfig,
    private userService : UserService,
    private domSanitizer : DomSanitizer,
    private shell : Shell
  ) { 
    super();
  }

  dismissAlert(alert : SiteWideAlert) {
    this.shell.dismissAlert(alert.id);
  }
  
  goToLogin() {
    this.userService.goToLogin();
  }
  
  readonly platformUrl = environment.urls.platform;
  
  user : ApiUser;
  isPastDue: boolean = false;
  showAccountMenu : boolean = false;
  siteWideMessage = '';
  siteWideUrl : SafeHtml = null;

  @Input()
  limited = false;

  @HostBinding('class.join-path')
  get isJoinPath() {
    return this.isInSection('/join');
  }
  
  get isModernPaymentFlow() {
    if (!this.shell.pageFlags)
      return false;
      
    return this.shell.pageFlags.includes('payment-flow:modern');
  }

  alerts : SiteWideAlert[] = [];

  communityEnabled = false;

  async init() {
    this.shell.alertsChanged.subscribe(alerts => this.alerts = alerts);

    this.communityEnabled = await this.appConfig.featureEnabled('apps.accounts.enable_community');

    this.userService.init();
    this.userService.userChanged.subscribe(user => {
      if (user && user.membership) {
        if (user.membership.payment_status === 'past_due') {
          this.isPastDue = true;
        }
      }
      this.user = user;
    });

    this.currentUrl = this.router.routerState.snapshot.url;
    this.router.events.subscribe(ev => {
      this.showAccountMenu = false;
      if (ev instanceof NavigationEnd) 
        this.currentUrl = ev.url;
    });

    this.showSiteWideMessage();
  }

  currentUrl : string;
  
  isInSection(url : string) {
    if (!this.currentUrl)
      return false;
    return this.currentUrl.startsWith(url);
  }

  async showSiteWideMessage() {
    await this.appConfig.appStatusReady;

    let settings = this.appConfig.appStatus.settings as any;
    if (!settings) 
      return;

    this.siteWideMessage = settings.site_alert_msg;
    if (settings.site_alert_url) {
      this.siteWideUrl = this.domSanitizer.bypassSecurityTrustUrl(settings.site_alert_url);
    } else {
      this.siteWideUrl = null;
    }
  }

  get appUrl() {
    return environment.urls.app;
  }

  get userGreeting() {
    let displayName = this.userDisplayName;

    if (displayName) 
      return `Hi ${displayName}!`;
    else 
      return `Hi!`;
  }
  
  get userDisplayName() {
    if (!this.user)
      return null;
    
    if (!this.user.profile)
      return null;
    
    if (this.user.profile.display_name)
      return this.user.profile.display_name;
    
    if (this.user.profile.first_name)
      return this.user.profile.first_name;
    
    if (this.user.display_name)
      return this.user.display_name;

    return null;
  }
}
